import { c as _c } from "react/compiler-runtime";
import { Button } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
import StickyBottomBox from '@/idv/components/layout/components/sticky-bottom-box';
import type { DeviceKind } from '../../../camera/types';
import type { CameraSide } from '../../../camera/utils/get-camera-options';
type PreviewProps = {
  imageSrc: string;
  onRetake: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  cameraKind: CameraSide;
  deviceKind: DeviceKind;
};
const Preview = t0 => {
  const $ = _c(32);
  const {
    imageSrc,
    onRetake,
    onConfirm,
    isLoading,
    cameraKind,
    deviceKind
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.components.photo-capture.preview"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  const t2 = deviceKind === "mobile" && "rounded-xl";
  const t3 = cameraKind === "front" && "-scale-x-100";
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = cx("rounded w-full", t2, t3);
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== cameraKind || $[5] !== deviceKind || $[6] !== imageSrc || $[7] !== t4) {
    t5 = <div className="flex items-start justify-center w-full flex-grow"><img data-dd-privacy="mask" src={imageSrc} data-camera-kind={cameraKind} data-device-kind={deviceKind} className={t4} alt="Preview" /></div>;
    $[4] = cameraKind;
    $[5] = deviceKind;
    $[6] = imageSrc;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = deviceKind === "mobile" && "gap-y-4";
  const t7 = deviceKind === "desktop" && "gap-y-2";
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = cx("flex justify-center items-center flex-col w-full", t6, t7);
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t) {
    t9 = t(_temp);
    $[12] = t;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== isLoading || $[15] !== onConfirm || $[16] !== t9) {
    t10 = <Button fullWidth={true} onClick={onConfirm} variant="primary" loading={isLoading} disabled={isLoading} size="large">{t9}</Button>;
    $[14] = isLoading;
    $[15] = onConfirm;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t) {
    t11 = t(_temp2);
    $[18] = t;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== isLoading || $[21] !== onRetake || $[22] !== t11) {
    t12 = <Button fullWidth={true} onClick={onRetake} variant="secondary" disabled={isLoading} size="large">{t11}</Button>;
    $[20] = isLoading;
    $[21] = onRetake;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== deviceKind || $[25] !== t10 || $[26] !== t12 || $[27] !== t8) {
    t13 = <StickyBottomBox><div className={t8} data-device-kind={deviceKind}>{t10}{t12}</div></StickyBottomBox>;
    $[24] = deviceKind;
    $[25] = t10;
    $[26] = t12;
    $[27] = t8;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t13 || $[30] !== t5) {
    t14 = <div className="flex items-center flex-col justify-center w-full -mb-8 max-md:px-2">{t5}{t13}</div>;
    $[29] = t13;
    $[30] = t5;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  return t14;
};
export default Preview;
function _temp($) {
  return $.confirm;
}
function _temp2($_0) {
  return $_0.retake;
}